import React from "react"
import GarnetLogo from "../images/garnet-logo.png"
import { Link } from "react-router-dom"

const Footer = () => (
  <div>
    <div
      className="email-block"
      style={{ marginTop: "50px", textAlign: "center" }}
    >
      <div className="container">
        <h1 className="primary-header">If you have questions</h1>
        <p>
          Please feel free to contact us by clicking the button below or sending
          an email to{" "}
          <a href="mailto:englishforlibya@garneteducation.com">
            englishforlibya@garneteducation.com
          </a>
        </p>
        <a href="mailto:englishforlibya@garneteducation.com">
          <button className="purple-button">Get in touch</button>
        </a>
      </div>
    </div>

    <div className="footer">
      <div className="container footer-wrapper">
        <img
          alt=""
          style={{ marginTop: "30px", marginBottom: "30px" }}
          src={GarnetLogo}
        />
        <Link className="privacy-link" to="privacy-policy">
          Privacy Policy
        </Link>
      </div>
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js